<template>
  <div class="components-content">
    <el-table ref="table" class="simple-table" :data="tableData" height="100%" highlight-current-row fit border v-loading='dataListLoading' >
      <el-table-column prop="name" label="场地名称" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="place" label="场地位置" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="area" label="场地面积" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="startTime" label="托管开始时间" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="endTime" label="托管结束时间" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="stateLabel" label="租凭情况" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="leaseStartTime" label="租赁开始时间" align="left" min-width="160" show-overflow-tooltip></el-table-column>
      <el-table-column prop="leaseEndTime" label="租赁结束时间" align="left" min-width="160" show-overflow-tooltip></el-table-column>
    </el-table>
    <div class="pagination-content" >
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="pageNum"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="totalSize">
      </el-pagination>
    </div>
  </div>
</template>

<script>
export default {
  name: 'siteManagement',
  data () {
    return {
      dataListLoading: false,
      tableData: [],
      pageNum: [10, 20, 30],
      pageSizes: 1,
      pageSize: 1,
      totalSize: 1,
      btnSize: 'small',
      sizeMini: 'mini'
    }
  },
  created () {
    this.handleQuery()
  },
  methods: {
    handleQuery () {
      console.log(this.$store.state.user.companyId)
      let companyId = this.$store.state.user.companyId || 0
      this.$tmp.getAreaDataForProperty(companyId).then((res) => {
        console.log(res)
        this.tableData = res
        // if (res.success) {
        //   this.tableData = res.data
        //   this.$refs.table.doLayout()
        // }
      })
    },
    handleSizeChange (val) {
      this.pageNum = 1
      this.pageSize = val
      this.handleQuery()
    },
    handleCurrentChange (val) {
      this.pageNum = val
      this.handleQuery()
    }
  }
}
</script>

<style lang="scss" scoped>
.components-content {
  height: 700px;
}
.simple-table {
  height: 700px;
}

.pagination-content {
  text-align: right;
}
</style>
